import React from "react";
import { array } from "prop-types";

import NewsWithNoImage from "../../../../molecules/NewsWithNoImage";

import "./organism1.m.css";

const Organism1 = ({ stories }) => (
  <div styleName="base">
    {stories.map(({ story }, index) => (
      <NewsWithNoImage key={index} story={story} />
    ))}
  </div>
);

Organism1.propTypes = {
  stories: array.isRequired,
};

export default Organism1;
